module.exports = __webpack_public_path__ + "static/media/upShgMeetTam.5776665d.jpg";